import './UserCases.sass'

import * as React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { MultiSizeImage } from '../Comparator'
import Comparator from '../Comparator/Comparator'

const UserCases = () => {
  const beforeLabel = (
    <div className='section-cases-before-label'>
      Before
    </div>
  )
  const afterLabel = (
    <div className='section-cases-after-label'>
      <span className='text-with-gradient'>After</span>
    </div>
  )

  return (
  <div className="section-cases">
    <section className="content">
      <StaticQuery
        query={queryCases}
        render={data => {
          const getImageByKey = (key: string): MultiSizeImage => ({
            desktop: data[key].childImageSharp.fixed,
            tablet: data[key + 'Tablet'].childImageSharp.fixed,
            mobile: data[key + 'Mobile'].childImageSharp.fixed,
          })
          return (
            <>
              <div className="section-cases-row">
                <div className="section-cases-comparator left">
                  <Comparator
                    reactOnClick={false}
                    beforeImage={getImageByKey('beforeImage1')}
                    afterImage={getImageByKey('afterImage1')}
                    beforeLabel={beforeLabel}
                    afterLabel={afterLabel}
                  />
                </div>
                <div className="section-cases-info">
                  <div className="section-cases-info-inner">
                    <span className="section-cases-category">Printing</span>
                    <span className="section-cases-title">Your print ideas deserve only the best possible quality</span>
                    <span className="section-cases-subtitle">Printing is not about average pictures. We are in charge to make your image as large as you need like it just shot on DSLR camera.</span>
                  </div>
                </div>
              </div>

              <div className="section-cases-row">
                <div className="section-cases-info left">
                  <div className="section-cases-info-inner">
                    <span className="section-cases-category">Real Estate</span>
                    <span className="section-cases-title">Boost sales of your property with a pinch of AI magic!</span>
                    <span className="section-cases-subtitle">Just upload an image and get it back ready for sale! Your leads will be impressed with the vivid colours and elaborate texture details</span>
                  </div>
                </div>
                <div className="section-cases-comparator right">
                  <Comparator
                    reactOnClick={false}
                    beforeImage={getImageByKey('beforeImage2')}
                    afterImage={getImageByKey('afterImage2')}
                    beforeLabel={beforeLabel}
                    afterLabel={afterLabel}
                  />
                </div>
              </div>

              <div className="section-cases-row">
                <div className="section-cases-comparator left">
                  <Comparator
                    reactOnClick={false}
                    beforeImage={getImageByKey('beforeImage3')}
                    afterImage={getImageByKey('afterImage3')}
                    beforeLabel={beforeLabel}
                    afterLabel={afterLabel}
                  />
                </div>
                <div className="section-cases-info">
                  <div className="section-cases-info-inner">
                    <span className="section-cases-category">E-commerce</span>
                    <span className="section-cases-title">Increase the conversion rates of your e-commerce</span>
                    <span className="section-cases-subtitle">Make it sharp to let the customer see all the details. Watch closer - the Devil is always into it.</span>
                  </div>
                </div>
              </div>
            </>
          )
        }}
      />
    </section>
  </div>
)
}

const queryCases = graphql`
  query {
    beforeImage1: file(relativePath: { eq: "comparator/before-4.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage1Tablet: file(relativePath: { eq: "comparator/before-4.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage1Mobile: file(relativePath: { eq: "comparator/before_mob-4.jpg" }) {
      childImageSharp {
        fixed(width: 312, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1: file(relativePath: { eq: "comparator/after-4.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1Tablet: file(relativePath: { eq: "comparator/after-4.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1Mobile: file(relativePath: { eq: "comparator/after_mob-4.jpg" }) {
      childImageSharp {
        fixed(width: 312, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage3: file(relativePath: { eq: "comparator/before-1.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage3Tablet: file(relativePath: { eq: "comparator/before-1.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage3Mobile: file(relativePath: { eq: "comparator/before-1.jpg" }) {
      childImageSharp {
        fixed(height: 400, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage3: file(relativePath: { eq: "comparator/after-1.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage3Tablet: file(relativePath: { eq: "comparator/after-1.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage3Mobile: file(relativePath: { eq: "comparator/after-1.jpg" }) {
      childImageSharp {
        fixed(height: 400, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    

    beforeImage2: file(relativePath: { eq: "comparator/before-2.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage2Tablet: file(relativePath: { eq: "comparator/before-2.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage2Mobile: file(relativePath: { eq: "comparator/before-2.jpg" }) {
      childImageSharp {
        fixed(height: 400, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage2: file(relativePath: { eq: "comparator/after-2.jpg" }) {
      childImageSharp {
        fixed(height: 420, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage2Tablet: file(relativePath: { eq: "comparator/after-2.jpg" }) {
      childImageSharp {
        fixed(height: 240, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage2Mobile: file(relativePath: { eq: "comparator/after-2.jpg" }) {
      childImageSharp {
        fixed(height: 400, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`

export default UserCases